export const COLORS = {
  navBg: "#0a2540",
  navIcon: "#5fb8c2",
  primary: "#0e7c86",
  primaryDark: "#0a5f67",
  primaryLight: "#e6f4f5",
  headerText: "#0e7c86",
  body: "#333",
  muted: "#777",
  border: "#e0e0e0",
  bgPage: "#f5f7fa",
  white: "#fff",
  success: "#4caf50",
  successLt: "#e8f5e9",
  warn: "#ff9800",
  warnLt: "#fff3e0",
  error: "#f44336",
  errorLt: "#fce4ec",
  info: "#1976d2",
  infoLt: "#e3f2fd",
  inherited: "#7b61ff",
  inheritedLt: "#f3f0ff",
  danger: "#c62828",
  successDark: "#2e7d32",
  warnDark: "#e65100",
};

/** Icons for location hierarchy levels (0 = jurisdiction, 1 = facility, 2+ = sub-locations). Used in tree and detail header. */
export const LOCATION_LEVEL_ICONS = ["🌎", "🏛️", "🏢", "📍", "🛏️"];

export const SPACING = {
  sectionGap: 24,
  cardPadding: 16,
  cardPaddingHorizontal: 20,
  cardMarginBottom: 12,
  formGroupGap: 16,
  formRowGap: 20,
  detailGap: 12,
};

export const AVAILABILITY_LABELS = {
  ALL_LEARNERS: "Open Access",
  BY_ASSIGNMENT_RETAIN_ACCOUNT_ON_MOVE: "Assignment Required",
  HIDDEN: "Hidden",
};

export const AVAILABILITY_OPTIONS = [
  { value: "ALL_LEARNERS", label: "Open Access (All Learners)" },
  { value: "BY_ASSIGNMENT_RETAIN_ACCOUNT_ON_MOVE", label: "Assignment Required" },
  { value: "HIDDEN", label: "Hidden" },
];

export const BOOLEAN_OPTIONS = [
  { value: "true", label: "Active" },
  { value: "false", label: "Suspended" },
];

export const BOOLEAN_OPTIONS_RESOURCE = [
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];

/** Location tree fixture for unit tests (e.g. utils.test.js, useConfigResolution.test.js). App uses API. */
export const LOCATIONS = [
  {
    id: "ga",
    name: "Georgia DOC",
    level: 0,
    children: [
      {
        id: "knox",
        name: "Knox County Jail",
        level: 1,
        children: [
          { id: "knox-a", name: "Unit A - General Pop", level: 2, children: [] },
          { id: "knox-b", name: "Unit B - Min Security", level: 2, children: [] },
          { id: "knox-c", name: "Unit C - Programs Wing", level: 2, children: [] },
        ],
      },
      {
        id: "fulton",
        name: "Fulton County CI",
        level: 1,
        children: [
          { id: "ful-e", name: "East Block", level: 2, children: [] },
          { id: "ful-w", name: "West Block", level: 2, children: [] },
        ],
      },
    ],
  },
  {
    id: "tn",
    name: "Tennessee DOC",
    level: 0,
    children: [
      {
        id: "hamilton",
        name: "Hamilton County Jail",
        level: 1,
        children: [
          { id: "ham-1", name: "Unit 1", level: 2, children: [] },
          { id: "ham-2", name: "Unit 2", level: 2, children: [] },
        ],
      },
    ],
  },
];

export const CONTENT_TABS = [
  { id: "browse", label: "Browse" },
  { id: "wizard", label: "Wizard" },
  { id: "templates", label: "Templates" },
];

export const WIZARD_STEPS = [
  "Select Template",
  "Select Locations",
  "Apply Mode",
  "Review & Confirm",
];

export const APPLY_MODES = [
  {
    id: "merge",
    title: "Merge",
    description: "Add entries to existing configs. Non-conflicting entries preserved. Overlapping entries (same service or resource name) updated with template values.",
    icon: "merge",
  },
  {
    id: "overwrite",
    title: "Overwrite",
    description: "Remove all existing direct configurations and overwrite with template contents. Inherited configurations remain unchanged.",
    icon: "overwrite",
  },
];
